module.exports = __webpack_public_path__ + "img/header-phone.c122632d.jpg";